import { NavLink } from 'react-router-dom'


const NavBar = () => {
    return (
        <>
        <header>
        <h1>Kari IoT Library for Arduino</h1>
        <p>Empowering your IoT projects with ease and flexibility</p>
    </header>
        <nav>
                <NavLink to="/" className={({isActive}) => isActive ? "active" : ""}>Home</NavLink>
                <NavLink to="/downloads" className={({isActive}) => isActive ? "active" : ""}>Download</NavLink>
                <NavLink to="/documentation" className={({isActive}) => isActive ? "active" : ""}>Documentation</NavLink>
                <NavLink to="/resources" className={({isActive}) => isActive ? "active" : ""}>Resources</NavLink>
                <NavLink to="/contacts" className={({isActive}) => isActive ? "active" : ""}>Contact</NavLink>
        </nav>
        </>
    )
}

export default NavBar
